import type { FC } from 'react';
import type { LucideIcon } from 'lucide-react';
import {
  Banknote,
  Compass,
  Earth,
  Globe,
  Landmark,
  Map,
  MapPin,
} from 'lucide-react';

import { EuIcon } from '@/shared/ui';

import type { RegionCode } from '../../libs/regions';

export interface RegionGlyphProps {
  className?: string;
  code: RegionCode;
}

const EU_REGIONS = new Set<RegionCode>(['EEA', 'EFTA', 'EU']);

const REGION_ICON: Partial<Record<RegionCode, LucideIcon>> = {
  AFRICA: Earth,
  APAC: Compass,
  ASIA: Compass,
  GCC: Landmark,
  GLOBAL: Globe,
  LATAM: Map,
  MENA: Landmark,
  'NORTH AMERICA': MapPin,
  SEPA: Banknote,
};

export const RegionGlyph: FC<RegionGlyphProps> = ({ className, code }) => {
  if (EU_REGIONS.has(code)) {
    return <EuIcon className={className ?? 'h-3.5 w-5 shrink-0'} />;
  }

  const Icon = REGION_ICON[code] ?? Globe;

  return (
    <Icon
      aria-hidden
      className={className ?? 'h-3.5 w-3.5 shrink-0 text-muted-foreground'}
    />
  );
};

RegionGlyph.displayName = 'RegionGlyph';
